import './EnrollmentEditor.less';
import React, {useState, useEffect} from 'react';
import __ from "../../i18n";
import CustomForm from "../../../bootstrap/components/custom-form/CustomForm";
import Request from "../../../bootstrap/api/Request";
import Toasts, {TOAST_SUCCESS} from "../../../bootstrap/scomponents/toasts/Toasts";
import EnrollmentCreateParcel from "../../api/endpoints/enrollment/EnrollmentCreateParcel";
import EnrollmentUpdateParcel from "../../api/endpoints/enrollment/EnrollmentUpdateParcel";
import listToSearchParcel from "../../api/convert/listToSearchParcel";
import listToFetchParcel from "../../api/convert/listToFetchParcel";
import CourseListParcel from "../../api/endpoints/course/CourseListParcel";
import UserListParcel from "../../api/endpoints/user/UserListParcel";
import {CURRENCY_INPUT_UNIT} from "../../view-constants/currency";
import {MAX_NUM} from "../../../bootstrap/utils/stats";


export default function EnrollmentEditor({recordId = null, defaultValues = {}, onDone, onCancel}) {

    const isCreation = recordId === null;

    const [values, setValues] = useState(defaultValues);

    const fieldsConfig = {
        course_id: {
            name: __('Course'),
            type: 'singleAjaxSelect',
            data: {
                ItemsSearchParcel: listToSearchParcel(CourseListParcel),
                ItemsFetchParcel: listToFetchParcel(CourseListParcel),
            },
            options: {
                renderOption: t => t.name,
            },
            rules: {
                required: true
            }
        },
        student_id: {
            name: __('Student'),
            type: 'singleAjaxSelect',
            data: {
                ItemsSearchParcel: listToSearchParcel(UserListParcel),
                ItemsFetchParcel: listToFetchParcel(UserListParcel),
            },
            options: {
                renderOption: t => __('::fullName (::email)', {
                    fullName: t.full_name,
                    email: t.email
                }),
            },
            rules: {
                required: true
            }
        },
        fee: {
            name: __('Fee'),
            type: 'number',
            rules: {
                required: true,
                min: 0,
                max: MAX_NUM
            },
            options: {
                unit: CURRENCY_INPUT_UNIT,
                appearance: 'box'
            },
            valueHint: values.fee !== null && values.fee >= 0 ? __('::amount(CURRENCY, symbol)', {amount: values.fee}) : undefined,
        },
    };

    const layoutConfig = [
        'course_id',
        'student_id',
        'fee',
    ];

    const submit = (values, onSuccess, onError) => {

        if (isCreation) {
            Request.add(new EnrollmentCreateParcel(values))
                .then((data) => {
                    Toasts.add(TOAST_SUCCESS, __('Your enrollment was added successfully'));
                    onSuccess();
                    onDone(data);
                })
                .catch(error => {
                    onError(error.getMessage());
                });

            return;
        }

        Request.add(new EnrollmentUpdateParcel(recordId, values))
            .then((data) => {
                Toasts.add(TOAST_SUCCESS, __('Your changes have been saved successfully'));
                onSuccess();
                onDone(data);
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    const cancel = () => {
        onCancel();
    };

    return <div className="enrollment-editor">
        <div className="sub-title">{__('Enrollment information')}</div>
        <CustomForm
            fieldsConfig={fieldsConfig}
            layoutConfig={layoutConfig}
            submitChanges={submit}
            cancel={cancel}
            submitText={isCreation ? __('Add enrollment') : __('Save changes')}
            defaultValues={defaultValues}
            onChange={setValues}
            onInitialized={setValues}
        />
    </div>;
}
